<template>
  <TGrid>
    <TGridItem :lg="8">
      <THeading :level="3">
        {{ rvRVName }}
      </THeading>

      <div class="mt-1 max-lg:text-sm/6">
        <div class="flex flex-wrap gap-x-4">
          <NuxtLink
            v-if="rvReviews?.length"
            to="#reviews"
          >
            <TRating
              :rating="rvRenterRating"
              :number-of-reviews="rvReviews.length"
              icon-variant="primary"
              is-clickable
            />
          </NuxtLink>

          <div class="flex gap-2 text-gray-500">
            <span>{{ t(`rvType.${rvRentalType}`) }}</span>
            <span class="select-none">-</span>
            <span>{{ t('rv.sleeps') }} {{ rvGuests }}</span>
            <span v-if="!rvIsStatic">
              <span class="select-none">-</span>
              {{ rvLength }} {{ t('unit.ft') }}
            </span>
          </div>
        </div>

        <RvRentalDistanceCalculation
          v-if="rvLocation"
          class="lg:mt-1"
        />
      </div>
    </TGridItem>
  </TGrid>
</template>

<script setup lang="ts">
const {
  rvRVName,
  rvReviews,
  rvRenterRating,
  rvRentalType,
  rvGuests,
  rvLength,
  rvLocation,
  rvIsStatic,
} = useRvDetails()

const { t } = useI18n()
</script>

<i18n src="~~/i18n/locales/common/units.json" lang="json" />
